import { formatMessage } from "devextreme/localization";

import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import SessionDetailDto from "../classes/dtos/usersessionmodule/SessionDetailDto";
import UserRightDto from "../classes/dtos/usersessionmodule/UserRightDto";

const UserSessionApi = {

    GetSessionDetailAsync: async function (): Promise<ProcessingResult<SessionDetailDto>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/UserSession/GetSessionDetail", {
            method: "get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new SessionDetailDto(data.customerName, data.workspaceName || formatMessage("Workspace_DefaultName"), data.subscriptionEnd !== null ? new Date(data.subscriptionEnd) : null, data.role, data.userIsMultiCustomer, data.withMetaAPI, data.enterpriseMode, data.withInternalAIAssistant, data.withCustomerAIAssistant, data.withAutoMapping, data.withAdvancedCustomerCredentials, data.withPortal, data.withFilterVisibility, data.withGlobalSettings, data.withWorkspaceSettings, data.withSso ?? false));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    GetUserRightsAsync: async function (screen: number): Promise<ProcessingResult<UserRightDto>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/UserSession/GetUserRights?screen=" + screen, {
            method: "get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(mapJsonToDto(data));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    }
};

function mapJsonToDto(json: any): UserRightDto {
    return new UserRightDto(json.screen, json.userRight, (json.childrens || []).map((child: any) => mapJsonToDto(child)));
}

export default UserSessionApi;